/**
 * shipmentNavigation.js — P0 SPRINT (Aug 2026)
 *
 * SMART SHIPMENT NAVIGATION ENGINE.
 *
 * Één canonical helper voor het openen van het volledige ShipmentDetail
 * dossier op de juiste tab. Alle modules (Global Search, Dashboard,
 * TrackingWidget, Recent Visits, ...) gebruiken deze helper — geen
 * hard-coded URL-strings meer verspreid over de codebase.
 *
 * Ondersteunde tabs (data-testids in ShipmentDetail):
 *   overzicht · colli · documenten · klant · consolidatie
 *   statusplanning · activiteit
 *
 * Context-hits vanuit search bepalen automatisch de juiste tab:
 *   Warehouse Receipt / Shipping Label → tab=documenten
 *   Sales Invoice                       → tab=documenten
 *   Colli / Piece                       → tab=colli
 *   Consolidation link                  → tab=consolidatie
 *   Klant                               → tab=klant
 *   Statusplanning                      → tab=statusplanning
 *   Activiteit                          → tab=activiteit
 */

export const SHIPMENT_TABS = [
  "overzicht",
  "colli",
  "documenten",
  "klant",
  "consolidatie",
  "statusplanning",
  "activiteit",
];

const CONTEXT_TAB_MAP = {
  warehouse_receipt: "documenten",
  shipping_label:    "documenten",
  document:          "documenten",
  invoice:           "documenten",
  factuur:           "documenten",
  packing_list:      "documenten",
  colli:             "colli",
  piece:             "colli",
  package:           "colli",
  status:            "statusplanning",
  statusplanning:    "statusplanning",
  activity:          "activiteit",
  activiteit:        "activiteit",
  audit:             "activiteit",
  consolidation:     "consolidatie",
  consolidatie:      "consolidatie",
  customer:          "klant",
  klant:             "klant",
};

export function resolveContextTab(context) {
  if (!context) return null;
  const key = String(context).toLowerCase().trim();
  return CONTEXT_TAB_MAP[key] || null;
}

/**
 * Bouw canonical URL voor ShipmentDetail deeplink.
 *
 * @param {object} opts
 * @param {string} [opts.wNumber]     — W-nummer fallback; may be shared by Agents
 * @param {string} [opts.shipmentId]  — stable dossier identity, always preferred
 * @param {string} [opts.tab]         — expliciete tab-key (SHIPMENT_TABS)
 * @param {string} [opts.context]     — context key (warehouse_receipt, invoice, etc.)
 * @param {string} [opts.source]      — analytics/telemetry hint (search, dashboard, recent, ...)
 */
export function buildShipmentUrl({ wNumber, shipmentId, tab, context, source } = {}) {
  const params = new URLSearchParams();
  params.set("section", "warehouse");
  if (shipmentId) {
    params.set("shipment_id", shipmentId);
  } else if (wNumber && String(wNumber).startsWith("W")) {
    params.set("w", wNumber);
  }
  const finalTab = tab || resolveContextTab(context);
  if (finalTab && SHIPMENT_TABS.includes(finalTab)) {
    params.set("tab", finalTab);
  }
  if (source) params.set("nav_source", source);
  return `/admin?${params.toString()}`;
}

/**
 * Direct navigeren naar ShipmentDetail (window.location.assign).
 * Gebruik voor click-handlers uit search-resultaten, dashboards, etc.
 */
export function openShipment(opts) {
  const url = buildShipmentUrl(opts);
  window.location.assign(url);
}
